module.exports = __webpack_public_path__ + "img/loading-new.bdd6e962.gif";